import { fromJS } from "immutable"
import {
  GET_LIST_RANKS_WATCHER,
  GET_LIST_RANKS_SUCCESS,
  GET_LIST_RANKS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoadingRanks: true,
  ranks: [],
})

function widgetAnalysisSegmentReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LIST_RANKS_WATCHER:
      return state.set("isLoadingRanks", true)

    case GET_LIST_RANKS_SUCCESS:
      return state.set("isLoadingRanks", false).set("ranks", action.payload)

    case GET_LIST_RANKS_FAILED:
      return state.set("isLoadingRanks", false).set("ranks", [])

    default:
      return state
  }
}

export default widgetAnalysisSegmentReducer
